export const ADD_LOADER = 'ADD_LOADER';
export const REMOVE_LOADER = 'REMOVE_LOADER';

export const INIT = 'INIT';

export const GET_USER_PREVIOUS_ORDERS_REQUEST = 'GET_USER_PREVIOUS_ORDERS_REQUEST';

export const GET_USER_ORDERS_REQUEST = 'GET_USER_ORDERS_REQUEST';
export const GET_USER_ORDERS_SUCCESS = 'GET_USER_ORDERS_SUCCESS';
export const GET_USER_ORDERS_FAILURE = 'GET_USER_ORDERS_FAILURE';

export const GET_REFERRAL_INFO_REQUEST = 'GET_REFERRAL_INFO_REQUEST';
export const GET_REFERRAL_INFO_SUCCESS = 'GET_REFERRAL_INFO_SUCCESS';
export const GET_REFERRAL_INFO_FAILURE = 'GET_REFERRAL_INFO_FAILURE';

export const FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST = 'FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST';
export const FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS = 'FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS';
export const FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE = 'FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE';

export const E_SIGN_ACCEPT_REQUEST = 'E_SIGN_ACCEPT_REQUEST';
export const E_SIGN_ACCEPT_SUCCESS = 'E_SIGN_ACCEPT_SUCCESS';
export const E_SIGN_ACCEPT_FAILURE = 'E_SIGN_ACCEPT_FAILURE';

export const REMOVE_DRIVER_ACCESS_REQUEST = 'REMOVE_DRIVER_ACCESS_REQUEST';
export const REMOVE_DRIVER_ACCESS_SUCCESS = 'REMOVE_DRIVER_ACCESS_SUCCESS';
export const REMOVE_DRIVER_ACCESS_FAILURE = 'REMOVE_DRIVER_ACCESS_FAILURE';
